<template>
  <div class="m-card card-gradient">
    <div class="header">
      <h4 class="tb_700">Assets Spending Graph</h4>
      <vs-select class="selectExample" v-model="select1" width="80px" disabled>
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item, index) in options1"
        />
      </vs-select>
    </div>
    <div class="content" v-if="delay == 1">
      <apexchart
        type="bar"
        :options="chartOptions"
        :series="series"
        height="250"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import ColumnChart from "@/components/ApexChart/ColumnChart.vue";
export default {
  props:{
    label:Array,
    dataChart:Array,
  },
  components: { ColumnChart },
  data() {
    return {
      delay: 0,
      select1: 6,
      options1: [
        { text: "Day", value: 0 },
        { text: "Week", value: 6 },
        { text: "Month", value: 29 },
      ],
      series: [
        {
          name: "Total Assets",
          data: this.dataChart,
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
        },
        legend: {
          show: true,
          position: "bottom",
          showForSingleSeries: true,
          horizontalAlign: "right",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.label,
        },
        yaxis: {
          //   title: {
          //     text: "$ (thousands)",
          //   },
          tickAmount: 4,
          min: 0,
        },
        fill: {
          opacity: 1,
        },
        // tooltip: {
        //   y: {
        //     formatter: function (val) {
        //       return "$ " + val + " thousands";
        //     },
        //   },
        // },
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.delay = 1;
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
.tb_700 {
  font-weight: 700;
  color: var(--text-color-2);
}
.header {
  display: flex;
  justify-content: space-between;
}
.card-gradient {
  background: linear-gradient(
    180deg,
    #429c93 0%,
    var(--background-color-sidebar) 50px,
    var(--background-color-sidebar) 100%
  );
}
.content {
  height: 250px;
  color: #000;
}
</style>